import React from 'react'
import styles from './ModalButton.module.scss'

type Props = {
  onClick: ()=> void;
  text: string;
  disabled?: boolean;
}

export const ModalButton = ({onClick, text, disabled}: Props) => {
  return (
    <button disabled={disabled} onClick={onClick} className={[styles.ModalButton, disabled ? styles.Disabled : ""].join(" ")}>
      {text}
    </button>
  )
}
